module.exports = __webpack_public_path__ + "static/media/AO.2490f4bd.svg";